var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.5 6.5a1 1 0 011-1h13a1 1 0 011 1v11a1 1 0 01-1 1h-13a1 1 0 01-1-1v-11zM23.5 17.5l-6-3v-5l6-3v11z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC41IDYuNUMwLjUgNS45NDc3MiAwLjk0NzcxNSA1LjUgMS41IDUuNUgxNC41QzE1LjA1MjMgNS41IDE1LjUgNS45NDc3MiAxNS41IDYuNVYxNy41QzE1LjUgMTguMDUyMyAxNS4wNTIzIDE4LjUgMTQuNSAxOC41SDEuNUMwLjk0NzcxNSAxOC41IDAuNSAxOC4wNTIzIDAuNSAxNy41VjYuNVoiIHN0cm9rZT0iY3VycmVudCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIzLjUgMTcuNUwxNy41IDE0LjVWOS41TDIzLjUgNi41VjE3LjVaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgVideo as ReactComponent };